import { z } from 'zod';

/**
 * プロダクト一覧の「公開範囲」絞り込みタブ。
 *
 * - public / restricted / internal: PUBLISHED かつ当該 publishScope のプロダクト
 * - all: PUBLISHED かつ publishScope ∈ {public, restricted, internal}
 *   （非公開 scope=NONE は完全除外）
 *
 * 非公開(NONE)のタブは存在せず、プロダクトタブには一切表示しない。
 */
const ProductPublishScopeFilterSchema = z.enum(['all', 'public', 'restricted', 'internal']);
export type ProductPublishScopeFilter = z.infer<typeof ProductPublishScopeFilterSchema>;
export const ProductTableFilterSchema = z.object({
  freeText: z.string().optional(),
  publishScope: ProductPublishScopeFilterSchema.catch('all').default('all'),
  pageIndex: z.coerce.number().min(0).default(0),
  pageSize: z.coerce.number().min(1).max(1000).default(100)
});